import {
  isPageSale,
  getExcludedSalesFpls,
  getFilteredExcludedFplsByAccount,
} from './selectors';

// Adds to `excludeFpls` any sales FPLs that need to be excluded for the
// specified page and user. For sale pages, it also gets the `fpls` for
// that page and user.
//
// Returns { excludeFpls, fpls? }
export default function salesFpls({ excludeFpls, tld, path, isVip }) {
  const params = {
    excludedFpls: excludeFpls,
    tld,
    isVip,
  };

  return isPageSale(path)
    ? getFilteredExcludedFplsByAccount(params)
    : { excludeFpls: getExcludedSalesFpls(params) };
}
